import React from 'react'
import styles from './MicrositeInlineEditRow.module.css'
import { Check, X } from 'lucide-react'

/**
 * MicrositeInlineEditRow
 * Expandable inline form row used above a table for quick add, or
 * inline within a row for quick edit — e.g. Redirects ("From path /
 * To path / Type") and Announcements. The actual fields are passed
 * as children so this stays layout-only.
 *
 * Usage:
 *   <MicrositeInlineEditRow
 *     onSave={handleSave}
 *     onCancel={() => setAdding(false)}
 *     saving={saving}
 *   >
 *     <TextInput value={fromPath} onChange={setFromPath} placeholder="/old-path" />
 *     <TextInput value={toPath} onChange={setToPath} placeholder="/new-path" />
 *   </MicrositeInlineEditRow>
 */
const MicrositeInlineEditRow = ({ children, onSave, onCancel, saving = false, saveLabel = 'Save' }) => (
    <div className={styles.row}>
        <div className={styles.fields}>{children}</div>
        <div className={styles.actions}>
            <button type="button" className={styles.saveBtn} onClick={onSave} disabled={saving}>
                <Check size={14} />
                {saving ? 'Saving…' : saveLabel}
            </button>
            <button type="button" className={styles.cancelBtn} onClick={onCancel} disabled={saving}>
                <X size={14} />
            </button>
        </div>
    </div>
)

export default MicrositeInlineEditRow